import SharedComponents from '../../../shared/ui';

export const DeployProjectButton = ({ onClick }: { onClick: () => void }) => {
  return <SharedComponents.CustomButton style="text" onClick={onClick} content="Deploy" />;
};
